(function (Drupal, drupalSettings) {
  Drupal.behaviors.pagesousmenu = {
    attach: function (context, settings) {
      document.querySelectorAll(".page-tags-wrapper").forEach((wrapper) => {
        const firstLink = wrapper.querySelector(".page-tags ul li a");
        const firstItem = wrapper.querySelector(".page-tags-item");

        if (firstLink) firstLink.classList.add("active");
        if (firstItem) firstItem.classList.add("active");

        wrapper.querySelectorAll(".page-tags ul li a").forEach((link) => {
          link.addEventListener("click", function (event) {
            const tagsLink = this.getAttribute("href");

            document
              .querySelectorAll(".page-tags ul li a")
              .forEach((el) => el.classList.remove("active"));
            this.classList.add("active");

            document
              .querySelectorAll(".page-tags-item")
              .forEach((el) => el.classList.remove("active"));
            const targetItem = document.querySelector(tagsLink);
            if (targetItem) targetItem.classList.add("active");

            const offset = targetItem ? targetItem.offsetTop - 300 : 0;
            window.scrollTo({ top: offset, behavior: "smooth" });

            history.pushState(null, null, tagsLink); // Ajoute le hash dans l'URL
          });
        });
      });

      document.addEventListener("DOMContentLoaded", () => {
        if (
          window.location.hash.length > 1 &&
          document.body.classList.contains("contenu_avec_sous_menu")
        ) {
          const hash = window.location.hash;
          const target = document.querySelector(hash);

          if (target) {
            const hashTop = target.offsetTop - 300;

            document.querySelectorAll(".page-tags ul li a").forEach((link) => {
              if (link.getAttribute("href") === hash) {
                document
                  .querySelectorAll(".page-tags ul li a")
                  .forEach((el) => el.classList.remove("active"));
                link.classList.add("active");

                document
                  .querySelectorAll(".page-tags-item")
                  .forEach((el) => el.classList.remove("active"));
                target.classList.add("active");
              }
            });

            window.scrollTo({ top: hashTop, behavior: "smooth" });
          }
        }
      });
    },
  };
})(Drupal, drupalSettings);

console.log("test log hel-24-33067-helora");
